import React from 'react';
import styled from 'styled-components';
import { ThemeColor,hoverEffect } from '../../utils/index';

function Card(props) {
    const Icon = props.icon;
    const clickHandler=(e)=>{
        props.clickCardHandler(e);
    };
    return (
        <CardContainer>
            <Icon />
            <Title onClick={clickHandler}>{props.title}</Title>
            {props.children}
        </CardContainer>
    );
}

const CardContainer = styled.div`
    max-height:max-content;
    min-height:220px;
    background-color:#fff;
    border-radius:1.2rem;
    width:33%;
    text-align:center;
    margin:10px 0;
    svg{
        font-size:4.6rem;
        padding:10px;
    }
    transition:0.4s ease-in-out;
    &:hover{
        box-shadow:${hoverEffect}
    }
    @media screen and (min-width: 320px) and (max-width: 1080px){
        width: 97%;
        margin:auto;
        margin-right:0;
        margin-top:10px;
    }
`;

const Title = styled.h2`
    color:${ThemeColor};
    cursor:pointer;
`;

export default Card;